<template>
  <b-form @submit.prevent="$emit('submit')">
    <b-form-group label="Nombre">
      <b-form-input v-model="formaPago.nombre" required type="text" placeholder="Nombre de la forma de pago" />
    </b-form-group>
    <botonera-edicion url-cancelar="/formasPago" />
  </b-form>
</template>
<script>
export default {
  props: {
    formaPago: Object,
  },
};
</script>
